<template>
  <el-row v-if="formConf" :gutter="formConf.gutter" class="center-board_row">
    <div v-if="formConf.type == 4" class="evaluation-total-score">
      <div class="total-scpre-title">总分</div>
      <div class="total-score">
        {{ totalScore }}
      </div>
    </div>
    <el-row class="center-name-box" align="middle" justify="center" type="flex">
      <el-col class="text-center" :span="21">
        <dt-tinymce v-model="formConf.title" :inline="true" @change="saveProjectInfo()" />
      </el-col>
    </el-row>
    <el-row class="center-desc-box" align="middle" justify="center" type="flex">
      <el-col :span="21">
        <div class="hide-tinymce" id="description">
          <!-- 这里输入框改成change事件，感觉会更好一点，要不然太频繁 -->
          <el-input
            ref="description"
            type="textarea"
            v-model="formConf.description"
            :autosize="{ minRows: 4 }"
            @change="saveProjectInfo()"
          ></el-input>
        </div>
      </el-col>
    </el-row>
    <el-divider />
    <div class="questionnaire">
      <draggable
        @start="$emit('start')"
        :animation="180"
        :list="drawingList"
        :move="(event) => $emit('move', event)"
        :group="{ name: 'group_draggable', pull: true, put: ['drawingList'] }"
        handle=".group_move"
        :force-fallback="true"
        :scroll="true"
        :scroll-sensitivity="160"
        @end="onGroupItemEnd($event)"
        @change="(obj) => onDraggableChange(obj, drawingList)"
      >
        <div
          v-for="(group, groupIndex) in drawingList"
          :key="group.id"
          class="drawing_list"
          :id="group.formItemGroupId"
          @click="activeGroupItem(group)"
        >
          <div class="question_group_wrap" :class="activeGroupId === group.id ? 'selected' : ''">
            <!-- 题目组头部 -->
            <div class="group-header flex-row align-center">
              <span class="group-handle hover_cursor_pointer" @click="toggleCollapse(groupIndex, !group.collapsed)"
                ><i
                  caret-id="caret-down-708"
                  class="fold-button"
                  :class="group.collapsed ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"
                ></i
              ></span>
              <div class="ground_name_input_box">
                <el-input
                  ref="groupNameInput"
                  class="ground_name_input"
                  v-model="group.name"
                  @input="(val) => handleInputGroupName(val, group.formItemGroupId)"
                >
                </el-input>
                <div class="ground_name_input_val" @click="handleFocusInput(groupIndex)">
                  {{ group.name }}
                </div>
              </div>
              <span class="question_num">(共计{{ group.items.length }}题)</span>
            </div>

            <!-- 题目列表 -->
            <template v-if="group.collapsed">
              <el-form
                :label-position="formConf.labelPosition"
                :label-width="formConf.labelWidth + 'px'"
                :size="formConf.size"
              >
                <draggable
                  class="drawing-board"
                  :id="group.formItemGroupId"
                  :list="group.items"
                  :animation="180"
                  :move="(event) => $emit('move', event)"
                  :force-fallback="true"
                  :scroll="true"
                  :scroll-sensitivity="160"
                  handle=".move"
                  :group="{ name: 'questions-item', pull: true, put: true }"
                  @start="$emit('start')"
                  @end="$emit('onItemEnd', $event)"
                >
                  <form-item-layout
                    v-for="(item, index) in group.items"
                    :key="item.renderKey"
                    :active-id="activeId"
                    :current-item="item"
                    :drawing-list="group.items"
                    :form-conf="formConf"
                    :index="index"
                    @activeItem="(val) => $emit('activeFormItem', val)"
                    @change="(currentItem) => $emit('updateProjectItemInfo', currentItem)"
                    @changeLabel="$emit('changeLabel')"
                    @copyItem="drawingItemCopy"
                    @deleteItem="drawingItemDelete"
                    @addInputItem="(currentItem) => $emit('drawingItemAddInputItem', currentItem)"
                    @uploadImg="(currentItem) => $emit('uploadImg', currentItem)"
                  />

                  <div v-if="!group.items.length" class="empty_info">
                    <img
                      src="data:image/png;base64,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"
                    />
                    <p>从左侧拖入或点选组件进行表单设计</p>
                  </div>
                </draggable>
              </el-form>
              <div class="group_bottom hover_cursor_pointer">
                <i
                  caret-id="caret-down-708"
                  class="el-icon-caret-top fold-button"
                  @click="toggleCollapse(groupIndex, false)"
                ></i>
              </div>
            </template>
          </div>
          <!-- 添加题目组 -->
          <div class="button-area hover_cursor_pointer">
            <el-button icon="el-icon-plus" type="text" @click="addGroup(groupIndex)">添加题目组</el-button>
          </div>

          <div class="operate_list">
            <el-tooltip
              v-for="item in operateList"
              :key="item.icon"
              effect="dark"
              :content="item.content"
              placement="top-start"
            >
              <div slot="content">{{ item.content }}</div>
              <span
                :class="[
                  `drawing-item__primary drawing-item__${item.type} group_${item.type}`,
                  { only_one: drawingList.length === 1 }
                ]"
                @click="operateClick(item.type, group, groupIndex)"
              >
                <i :class="item.icon" />
              </span>
            </el-tooltip>
          </div>
        </div>
      </draggable>
    </div>
    <div class="placeholder_box"></div>
  </el-row>
</template>

<script>
import FormItemLayout from './FormItemLayout'
import draggable from 'vuedraggable'
import { operateList } from './constant'
import { debounce } from 'throttle-debounce'
import { deepClone, removeHtmlTag } from '@/utils'
import { formItemConvertData } from '@/utils/convert'
import {
  deleteProjectItem,
  updateProject,
  createGroup,
  deleteGroup,
  groupMove,
  copyGroup,
  editGroup
} from '../../../api/project/form'
import mixin from './mixin'
import DtTinymce from '@/components/DtTinymce/index.vue'

export default {
  name: 'CenterPanel',
  components: {
    FormItemLayout,
    draggable,
    DtTinymce
  },
  mixins: [mixin],
  props: ['formConf', 'formKey', 'drawingList', 'activeId', 'activeGroupId', 'currenGroupItem'],
  data() {
    return {
      operateList: operateList
    }
  },
  computed: {
    totalScore() {
      let total = 0
      this.drawingList.forEach((item) => {
        if (item.examConfig && item.examConfig.score) {
          total += item.examConfig.score
        }
      })
      return total
    }
  },
  watch: {},
  methods: {
    /**
     * 统一触发多个 $emit
     * @param {Object} updates - 事件名和对应的值
     */
    emitUpdates(updates) {
      Object.entries(updates).forEach(([key, value]) => this.$emit(`update:${key}`, value))
    },

    //更新问卷标题和描述
    saveProjectInfo: debounce(200, true, function () {
      this.showLoading = true
      updateProject({
        formKey: this.formKey,
        name: this.formConf.title,
        description: this.formConf.description
      }).then(() => {
        const PATH = process.env.VUE_APP_API_ROOT + '/workOrderLogic/querySimpleFormNameMap'
        this.$store.commit('cache/clearCache', `${PATH}>respone`)
        this.showLoading = false
        this.$store.dispatch('form/setFormTitle', removeHtmlTag(this.formConf.title))
      })
    }),
    // 复制题目
    drawingItemCopy(item, list) {
      const clone = this.createIdAndKey(deepClone(item))
      // list.push(clone)
      // this.$emit(`activeFormItem`, clone)
      // 保存之后会自动选中，这里不需要添加进去
      this.$emit(`saveProjectItemInfo`, clone, true)
      // 加标识进行滚动
      this.$emit(`update:operate`, 'addComponentItem')
    },
    // 删除题目
    drawingItemDelete(item, list) {
      this.showLoading = true
      const data = formItemConvertData(item, this.formKey)
      deleteProjectItem(data).then(() => {
        console.log('删除组件')
        // 接口返回成功之后再删除数组项
        const index = list.findIndex((val) => val.config.formId === item.config.formId)
        list.splice(index, 1)
        this.$emit('getOutLineList')
        this.$emit('resetActiveFormItem')
        this.showLoading = false
      })
    },
    /**
     * 选中某个分组
     * @param {Object} currentItem - 当前选中的分组
     */
    activeGroupItem(currentItem) {
      if (!currentItem) return
      this.emitUpdates({
        currenGroupItem: currentItem,
        activeGroupId: currentItem.id || null,
        activeId: 0
      })
      // 选中的同时清除右边的题目属性
      this.$emit('resetActiveFormItem')
    },

    /**
     * 在对应题目组位置后新增题目组
     */
    async addGroup(groupIndex) {
      try {
        // 这里的索引传要增加的位置，所以加一，配合后端
        const { code } = await createGroup(this.formKey, groupIndex + 1)
        if (code === 200) {
          this.$message.success('添加成功')
          // 加标识进行滚动
          this.$emit(`update:operate`, 'addComponentGroup')
          await new Promise((resolve) => {
            this.$emit('queryProjectItems', resolve)
          })
          this.$emit('getOutLineList')
        }
      } catch (error) {
        console.error('添加题目组失败:', error)
      }
    },

    async operateClick(type, groupItem, groupIndex) {
      try {
        if (type === 'copy') {
          await copyGroup({ formKey: this.formKey, formItemGroupId: groupItem.formItemGroupId })
          // 加标识进行滚动
          this.$emit(`update:operate`, 'addComponentGroup')
          await new Promise((resolve) => {
            this.$emit('queryProjectItems', resolve)
          })
          this.$emit('getOutLineList')
        } else if (type === 'delete') {
          await this.removeGroup(groupItem, groupIndex)
        }
      } catch (error) {
        console.error(`操作失败: ${type}`, error)
      }
    },

    // 删除题目组
    removeGroup(groupItem, groupIndex) {
      this.$confirm('删除后，对应题目的答卷数据也将一并删除且无法恢复，请确认是否删除!', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'del-model'
      }).then(async () => {
        await deleteGroup({ formKey: this.formKey, formItemGroupId: groupItem.formItemGroupId })
        this.drawingList.splice(groupIndex, 1)
        // 删除选中的分组时，自动选中删除分组的下一个分组
        if (groupItem.id === this.activeGroupId) {
          const { drawingList } = this
          // 判断删除的选中分组是不是最后一个分组
          const setActiveGroupItem =
            groupIndex === drawingList.length ? drawingList[groupIndex - 1] : drawingList[groupIndex]
          this.emitUpdates({
            currenGroupItem: setActiveGroupItem,
            activeGroupId: setActiveGroupItem.id || null
          })
        }

        this.$emit('getOutLineList')
      })
    },
    toggleCollapse(groupIndex, status) {
      this.$set(this.drawingList[groupIndex], 'collapsed', status)
      this.$forceUpdate() // 强制刷新
    },
    // 分组移动结束回调
    onGroupItemEnd(groupObj) {
      const { newIndex, oldIndex, clone, to } = groupObj

      if (groupObj.newIndex === groupObj.oldIndex || to.className === 'drawing-board') return
      const step = newIndex - oldIndex
      groupMove({ step, handleFormItemGroupId: clone.id, formKey: this.formKey }).then((res) => {
        this.$emit('getOutLineList')
      })
    },
    handleInputGroupName(name, formItemGroupId) {
      editGroup({ name, formItemGroupId, formKey: this.formKey }).then((res) => {
        this.$emit('getOutLineList')
      })
    },
    handleFocusInput(index) {
      this.$refs.groupNameInput[index].focus()
    },
    onDraggableChange(evt) {
      // 如果元素被删除（拖出列表），判断是否需要恢复
      if (evt.removed) this.restoreItem(evt.removed.element)
    },
    restoreItem(item) {
      // 检查数据是否真的丢失
      const exists = this.drawingList.some((group) => group.formItemGroupId === item.formItemGroupId)
      if (!exists) {
        console.log('数据丢失，重新获取')
        this.$emit('queryProjectItems')
      }
    },
    focusDescription() {
      this.$refs.description?.focus()
    }
  }
}
</script>
<style lang="scss" scoped>
.questionnaire {
  .question_group_wrap {
    border: 1px dashed #ccc;
    padding: 10px 20px;
    position: relative;
    font-size: 16px;

    &.selected {
      border: 1px dashed #2672ff;
    }
    .group-header {
      margin-bottom: 10px;

      .group-handle {
        display: flex;
        align-items: center;
      }
      .group_bottom {
        padding: 0 9px;
      }
    }
  }
  .button-area {
    text-align: center;
  }
}
.ground_name_input_box {
  display: inline-block;
  position: relative;
  .ground_name_input_val {
    opacity: 0;
    padding: 0 12px;
  }
  input:focus {
    outline: 0;
  }
}
.ground_name_input {
  width: 100%;
  height: 100%;
  display: inline-block;
  height: 100%;
  width: 100%;
  background: inherit; /**继承父级**/
  position: absolute;
  left: 0;
  top: 0;
  padding: 0;
  opacity: 1;
  border: none;
  ::v-deep .el-input__inner {
    border: none;
    width: 100%;
    height: 100%;
    padding: 0 10px;
    color: #606266;
    font-weight: 600;
    font-size: 16px;
  }
}
.question_num {
  color: #909399;
  font-size: 12px;
}
</style>
